import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import MandantPicker from './pages/MandantPicker';
import BelegeList from './pages/BelegeList';
import BelegDetail from './pages/BelegDetail';
import LieferantenList from './pages/LieferantenList';
import KundenList from './pages/KundenList';
import AusgangList from './pages/AusgangList';
import Journal from './pages/Journal';
import Susa from './pages/Susa';
import Kontenblatt from './pages/Kontenblatt';
import Ustva from './pages/Ustva';
import Opl from './pages/Opl';
import Bank from './pages/Bank';
import './App.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Layout />}>
            <Route path="/mandanten" element={<MandantPicker />} />
            <Route path="/mandanten/:slug/belege" element={<BelegeList />} />
            <Route path="/mandanten/:slug/belege/:id" element={<BelegDetail />} />
            <Route path="/mandanten/:slug/lieferanten" element={<LieferantenList />} />
            <Route path="/mandanten/:slug/kunden" element={<KundenList />} />
            <Route path="/mandanten/:slug/ausgang" element={<AusgangList />} />
            <Route path="/mandanten/:slug/journal" element={<Journal />} />
            <Route path="/mandanten/:slug/reports" element={<Susa />} />
            <Route path="/mandanten/:slug/reports/ustva" element={<Ustva />} />
            <Route path="/mandanten/:slug/reports/opl" element={<Opl />} />
            <Route path="/mandanten/:slug/bank" element={<Bank />} />
            <Route path="/mandanten/:slug/reports/konto/:konto" element={<Kontenblatt />} />
          </Route>
          <Route path="/" element={<Navigate to="/mandanten" replace />} />
          <Route path="*" element={<Navigate to="/mandanten" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
